import { fontColorForBackground } from '../utils/colors'
import { getColor } from '../utils/bike-schema'
import { t } from '../utils/i18n'

const LatestRal = ({ onSelect, latestPickedRals }) => {
  const listSize = 10
  return (
    <div>
      <div className="velorbis-customizer-ral-picker-color head">
        {t('last_color')}:
      </div>
      {latestPickedRals.slice(0, listSize).map((ral) => (
        <div
          key={ral}
          className="velorbis-customizer-ral-picker-color"
          style={{
            backgroundColor: getColor(ral).hex,
            color: fontColorForBackground(getColor(ral).hex)
          }}
          data-ral={`Q${ral}`}
          onClick={() => onSelect(ral)}
        >
          <div className="velorbis-customizer-ral-picker-color-name">
            RAL {ral}: {getColor(ral).name}
          </div>
        </div>
      ))}
      <div className="velorbis-customizer-ral-picker-separator__with-spacing" />
    </div>
  )
}

export default LatestRal
